module.exports = __webpack_public_path__ + "img/landing-home-speaker-500.808ac89b.png";